import { Stage } from 'models/Stage';
import { Character } from 'models/Character';
import { League } from 'models/League';
import { Request } from 'components/Request';

class Season extends CacheableDataObject {
	afterConstruct() {
		this.getCharactersPromise = null;
		this.getStagesPromise = null;
	}

	getUnrankedTier() {
		if(this.unrankedTier) {
			return this.unrankedTier;
		}

		this.unrankedTier = this.tiers.find((tier) => {
			return tier.isUnranked();
		});
		return this.unrankedTier;
	}

	getStages() {
		if(this.getStagesPromise) {
			return this.getStagesPromise;
		}

		return this.getStagesPromise = new Promise((resolve, reject) => {
			if(this.stages) {
				resolve(this.stages);
				this.getStagesPromise = null;
			}
			else {
				Request.apiv1Get('ladders/season_stages', { season_id: this.id })
					.then((response) => {
						const stagesMerged = _.assign({}, response.stages.starter, response.stages.counterpick);
						this.update({
							stages: stagesMerged
						});
						resolve(this.stages);
					})
					.catch((response) => {
						reject(response);
					})
					.finally(() => {
						this.getStagesPromise = null;
					});
			}
		});
	}

	getCharacters() {
		if(this.getCharactersPromise) {
			return this.getCharactersPromise;
		}

		return this.getCharactersPromise = new Promise((resolve, reject) => {
			if(this.characters) {
				resolve(this.characters);
				this.getCharactersPromise = null;
			}
			else {
				Request.apiv1Get('ladders/season_characters', { season_id: this.id })
					.then((response) => {
						this.update({
							characters: response.characters
						});
						resolve(this.characters);
						this.getCharactersPromise = null;
					})
					.catch((response) => {
						reject(response);
						this.getCharactersPromise = null;
					});
			}
		});
	}

	getCharacterById(characterId) {
		return this.characters.get(characterId);
	}

}

Season.prototype.dataLocationParsers = {
	// Calendar dates, "Y-m-d" as Ladder_Season::array_serialize sends them.
	end_date: (season, data) => {
		season.end_date = data.end_date || null;
	},
	start_date: (season, data) => {
		season.start_date = data.start_date || null;
	},
	tiers: function(season, data) {
		season.tiers = [];
		_.each(data.tiers, (value, key) => {
			season.tiers[key] = League.retrieve(value);
		});
	},
	stages: (season, data) => {
		season.stages = new Map();
		_.each(data.stages, (stage) => {
			const theStage = Stage.retrieve(stage);
			season.stages.set(theStage.id, theStage);
		});

	},
	characters: function(season, data) {
		if(!season.characters) {
			season.characters = new Map();
		}
		if(data.characters instanceof Map) {
			season.characters = data.characters;
		}
		else {
			for(let i in data.characters) {
				if(!data.characters.hasOwnProperty(i)) {
					continue;
				}
				const characterData = data.characters[i];
				const character = Character.retrieve(characterData);
				if(!character.id) {
					console.error('who is this');
					console.log(data);
					console.log(characterData);
					console.log(character);
					continue;
				}
				season.characters.set(character.id, character);
			}
		}
	},
};

export { Season };